var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-flex-grid',_vm._b({attrs:{"url-path":_vm.$api.journals.planResByShiftPlywoodEquipmentGroupPlywoodCmplTrans,"url-query":{
        idPlanResByShiftPlywoodEquipmentGroupPlywoodCmpl: _vm.parent.Id,
    },"sortable":"","is-subcomponent":""}},'c-flex-grid',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }